<template>
    <div class="stepeFiveRoot">
      <div class="circleItem"><CircleVue currentIndex="5"></CircleVue> </div>
      <div class="backPageItem"><BackPageVue  @backPreviewPage="hanldGoBack"></BackPageVue> </div>

        <div>
            <div class="titleLine">Let’s Learn More About Your Work</div>
        </div>

        <div class="inputBlock">
          <div class="fieldLine">When was your most recently published paper?</div>
          <div class="inputLine">
            <el-date-picker  v-model="yearValue" type="year" value-format="yyyy" format="yyyy" :picker-options="pickerOptions"  placeholder="2025"> </el-date-picker>
            <!-- <el-input v-model.number="yearValue" placeholder="2025" type="tel"  @input="value=>handleInput(value,1)"  @keydown.native="handleKeyDown"></el-input> -->
            <span  class="fieldLine">year</span>
          </div>
        </div>
        <div  class="inputBlock">
          <div class="fieldLine">How many papers have you published in total?</div>
          <div class="inputLine">
            <el-input v-model.number="numValue" placeholder="8"  type="tel" @input="value=>handleInput(value,2)"  @keydown.native="handleKeyDown"></el-input>
            <div  class="fieldLine" style="white-space: nowrap;">paper (includes prepreints)</div>
          </div>
        </div>
      
       
      
        <div class="btnLine">
          <div class="disBtn" v-if="!(yearValue&&numValue)">Next</div>
          <div class="chooseBtn" v-else @click="goToNextStep">Next</div>
        </div>
        <div class="LastLine">
            <div class="skipBtn" @click="goToNextStep(-1)">Skip</div>
        </div>
        <div class="LastLine2">
          <div class="oneItem">© 2025 PaperSpotlight. All rights reserved.</div>
          <!-- <div class="twoItem">The data presented is based on our independent research and analysis. While we strive for accuracy, results may vary across different fields and contexts. Unauthorized reproduction or distribution of this content is prohibited.</div> -->
      </div>
    </div>
</template>
<script>
import CircleVue from './circle.vue'
import BackPageVue from './backPage.vue'

export default {
    components:{CircleVue,BackPageVue},
    data(){
      return{
        imgObj:{
          guideHomebg1:require("../../assets/img/main/guideHomebg1.png"),
          guideHomebg2:require("../../assets/img/main/guideHomebg2.png"),
        },
        yearValue:'',
        numValue:'',
        pickerOptions: {
        disabledDate(time) {
          return time.getFullYear() > new Date().getFullYear();
        }
      }
      }
  },
  mounted: function() {
    let userData = JSON.parse(localStorage.getItem('userData'))
    if(userData&&userData.stepFive&&userData.stepFive.length){
      this.yearValue = userData&&userData.stepFive&&userData.stepFive[0]
      // this.yearValue = this.yearValue.toString()
      this.numValue = userData&&userData.stepFive&&userData.stepFive[1] 
    }
  },
  methods:{
    // handleFocus(e) {
    //   // 立即移除焦点，阻止键盘弹出
    //   e.target.blur();
    //   // 手动触发选择面板
    //   this.$refs.yearPicker.focus();
    // },
    // handleClick() {
    //   // 确保选择面板能正常打开
    //   this.$refs.yearPicker.focus();
    // },
    hanldGoBack(){
      localStorage.setItem('guideIndex', 4);
      this.$emit('changePage', 4);
    },
     // 处理输入，确保只能是数字
    handleInput(value,item) {
      if(item == 1){
        this.yearValue = value.replace(/[^\d]/g, '')
      }else{
        this.numValue = value.replace(/[^\d]/g, '')
      }
    },
    // 阻止非数字键的默认行为
    handleKeyDown(e) {
      const allowedKeys = [
        8,   // Backspace
        9,   // Tab
        13,  // Enter
        37,  // Left arrow
        38,  // Up arrow
        39,  // Right arrow
        40,  // Down arrow
        46,  // Delete
        48, 49, 50, 51, 52, 53, 54, 55, 56, 57,  // 数字0-9
        96, 97, 98, 99, 100, 101, 102, 103, 104, 105  // 小键盘数字0-9
      ]
      
      if (!allowedKeys.includes(e.keyCode) && 
          !(e.ctrlKey && [65, 67, 86, 88].includes(e.keyCode))) {  // 允许Ctrl+A/C/V/X
        e.preventDefault()
      }
    },
    goToNextStep(index){   
      localStorage.setItem('guideIndex', 6);

      let userData = JSON.parse(localStorage.getItem('userData'))||{}
      if(this.yearValue && this.numValue){
        userData.stepFive =[this.yearValue,parseInt(this.numValue)]
        let str = JSON.stringify(userData)
        localStorage.setItem('userData', str);
      }else{
        userData.stepFive = []
        let str = JSON.stringify( userData)
        localStorage.setItem('userData', str);
      }
       this.$emit('changePage', 6);

    }
  }
}
</script>

<style lang="scss">
// /* 隐藏输入框光标 */
// .el-date-editor input {
//   caret-color: transparent;
// }
.inputLine .el-input--prefix .el-input__inner{
  padding-left:20px !important;
  padding-right:0px !important;
}

.inputLine .el-date-editor.el-input, .el-date-editor.el-input__inner{
  width: 110px !important;
}
.el-picker-panel__icon-btn:hover{
  color: #feae00 !important;
}
.el-year-table td .cell:hover, .el-year-table td.current:not(.disabled) .cell{
  color: #feae00 !important;
}
.el-year-table td.today .cell{
  color: #feae00 !important;
}
.inputLine .el-input__inner {
  width: 110px !important;
  // border: none !important;
  // border-bottom: 1px solid #000 !important;
  // border-radius: 0 !important;
  // padding-left: 0 !important;
  // padding-right: 0 !important;
}

.inputLine .el-input__inner:focus {
  border-bottom-color: #feae00 !important;
}
.inputLine .el-input__inner{
  color: var(---2, #333);
    text-align: center;
    font-size: 18px !important;
}
.stepeFiveRoot{
    width: 100%;
    // height: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 60px 0 30px 0;
    gap: 50px;
    position: relative;
    .backPageItem{
      position: absolute;
      left: 100px;
      top:40px;
      width: 30px;
      height: 30px;
    }
    .circleItem{
      position: absolute;
      right: 100px;
      top:40px;
      width: 50px;
      height: 50px;
    }
    .titleLine{
      color: #000;
      text-align: center;
      font-family: "Times New Roman";
      font-size: 40px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-transform: capitalize;
    }
    .subTitle{
        margin-top: 10px;
        max-width: 900px;
        color: var(---2, #333);
        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-transform: capitalize;
    }
    .inputBlock{
      // width: 50%;
      width: 550px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 12px;
    }
    .fieldLine{
        color: var(---2, #333);
        text-align: center;

        /* 一级标题 */
        font-family: "Times New Roman";
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        // text-transform: capitalize;
    }
    .inputLine{
      display: flex;
      gap: 12px;
      align-items: center;
    }
   .cascadeSelect{
        display: flex;
        gap: 20px;
        .el-select{
            width: 320px;
        }
   }
    .btnLine{
          display: flex;
        justify-content: center;
        align-items: center;
        .disBtn{
            display: inline-block;
            background: #E0E0E0;
            color: #fff;
            padding: 12px 40px;
            border-radius: 8px;
            font-size: 16px;
        }
        .chooseBtn{
            cursor: pointer;
            display: inline-block;
            background: #212121;
            color: #fafafa;
            padding: 12px 40px;
            border-radius: 8px;
            font-size: 16px;
        }
        .chooseBtn:hover{
            background: #424242;
        }
        .chooseBtn:active{
            background: #212121;
        }
        

    }
    .LastLine{
        display: flex;
        justify-content: center;
        align-items: flex-end;
        margin-top: -50px;
      .skipBtn{
          cursor: pointer;
          padding: 12px 40px;
            font-size: 16px;
            color: #999;
        }
      }
    .LastLine2{
      flex: 1 1;
      display: flex;
        justify-content: center;
        align-items: flex-end;
        // margin-top: -20px;
        .oneItem{
          color: var(---1, #000);
          text-align: center;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 22px; /* 110% */
        }
        .twoItem{
          width: 90%;
          max-width: 900px;
          color: #aaa;
          text-align: center;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
    }
}
@media screen and (max-width:767px) { 
  .stepeFiveRoot{
    width: 100%;
    // height: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20vw 6vw 10vw 6vw;
    gap: 10vw;
    position: relative;
    .backPageItem{
      position: absolute;
      left: 2vw;
      top:3vw;
      width: 4vw;
      height: 4vw;
    }
    .circleItem{
      position: absolute;
      right: 2vw;
      top:3vw;
      width: 8vw;
      height: 8vw;
    }
    .titleLine{
      color: #000;
      text-align: center;
      font-family: "Times New Roman";
      font-size: 6vw;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-transform: capitalize;
    }
    .subTitle{
        margin-top: 2vw;
        max-width: 900px;
        color: var(---2, #333);
        text-align: center;
        font-size: 3.4;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-transform: capitalize;
    }
    .inputBlock{
      // width: 50%;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 12px;
    }
    .fieldLine{
        color: var(---2, #333);
        text-align: start;

        /* 一级标题 */
        font-family: "Times New Roman";
        font-size: 4vw;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        // text-transform: capitalize;
    }
    .inputLine{
      display: flex;
      gap: 2vw;
      align-items: center;
    }
   .cascadeSelect{
        display: flex;
        gap: 20px;
        .el-select{
            width: 320px;
        }
   }
    .btnLine{
          display: flex;
        justify-content: center;
        align-items: center;
        .disBtn{
            display: inline-block;
            background: #E0E0E0;
            color: #fff;
            padding: 1.2vw 4vw;
            border-radius: 8px;
            font-size: 3.4vw;
        }
        .chooseBtn{
            cursor: pointer;
            display: inline-block;
            background: #212121;
            color: #fafafa;
            padding: 1.2vw 4vw;
            border-radius: 8px;
            font-size: 3.4vw;
        }
        .chooseBtn:hover{
            background: #424242;
        }
        .chooseBtn:active{
            background: #212121;
        }
        

    }
    .LastLine{
        display: flex;
        justify-content: center;
        align-items: flex-end;
        margin-top: -6vw;
      .skipBtn{
          cursor: pointer;
          padding: 1.2vw 4vw;
            font-size: 3.4vw;
            color: #999;
        }
      }
      .LastLine2{
        flex: 1 1;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        // margin-top: -4vw;
        .oneItem{
            color: var(---1, #000);
            text-align: center;
            font-size: 3.4vw;
            font-style: normal;
            font-weight: 400;
            line-height: 1.3; /* 110% */
          }
          .twoItem{
            width: 90%;
            max-width: 900px;
            color: #aaa;
            text-align: center;
            font-size: 3vw;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
          }
    }
}
}


@media screen  and (min-width: 767px) and (max-width: 1200px){
  .stepeFiveRoot{
    width: 100%;
    // height: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 6vw 0 3vw;
    gap: 5vw;
    position: relative;
    .backPageItem{
      position: absolute;
      left: 6vw;
      top:2vw;
      width: 5vw;
      height: 5vw;
    }
    .circleItem{
      position: absolute;
      right: 6vw;
      top:2vw;
      width: 5vw;
      height: 5vw;
    }
    .titleLine{
      color: #000;
      text-align: center;
      font-family: "Times New Roman";
      font-size: 3.2vw;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-transform: capitalize;
    }
    .subTitle{
        margin-top: 10px;
        max-width: 900px;
        color: var(---2, #333);
        text-align: center;
        font-size: 1.6vw;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-transform: capitalize;
    }
    .inputBlock{
      // width: 50%;
      width: 52vw;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 1.2vw;
    }
    .fieldLine{
        color: var(---2, #333);
        text-align: center;

        /* 一级标题 */
        font-size: 2.4vw;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        // text-transform: capitalize;
    }
    .inputLine{
      display: flex;
      gap: 1.2vw;
      align-items: center;
    }
    .btnLine{
          display: flex;
        justify-content: center;
        align-items: center;
        .disBtn{
            display: inline-block;
            background: #E0E0E0;
            color: #fff;
            padding: 1.2vw 4vw;
            border-radius: 8px;
            font-size: 1.6vw;
        }
        .chooseBtn{
            cursor: pointer;
            display: inline-block;
            background: #212121;
            color: #fafafa;
            padding: 1.2vw 4vw;
            border-radius: 8px;
            font-size: 1.6vw;
        }
        .chooseBtn:hover{
            background: #424242;
        }
        .chooseBtn:active{
            background: #212121;
        }
        

    }
    .LastLine{
        display: flex;
        justify-content: center;
        align-items: flex-end;
        margin-top: -5vw;
      .skipBtn{
          cursor: pointer;
          padding: 1.2vw 4vw;
            font-size: 1.6vw; 
            color: #999;
        }
      }
      .LastLine2{
        flex: 1 1;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        // margin-top: -1vw;
        .oneItem{
          color: var(---1, #000);
          text-align: center;
          font-size: 1.6vw;
          font-style: normal;
          font-weight: 400;
          line-height: 1.3; /* 110% */
        }
        .twoItem{
          width: 90%;
          max-width: 900px;
          color: #aaa;

          text-align: center;
          font-size: 1.2vw;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
    }
}
}
</style>


